import React, { Component } from "react";
import * as s from "./UserLoginModal.module.scss";
import {
  Button,
  Input,
  Modal,
  P,
  PseudoLink,
} from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { inject, observer } from "mobx-react";
import {
  AuthenticationStore,
  LoginStore,
  RegisterStore,
  UIStore,
} from "src/stores";
import { tx } from "src/libs/i18n";

interface Props {
  loginStore?: LoginStore;
  registerStore?: RegisterStore;
  authenticationStore?: AuthenticationStore;
  uiStore?: UIStore;
}

@inject("loginStore", "registerStore", "authenticationStore", "uiStore")
@observer
export class UserLoginModal extends Component<Props> {
  render() {
    const {
      loginStore,
      registerStore,
      authenticationStore,
      uiStore,
    } = this.props;
    const {
      login,
      closeLoginModal,
      userEmail,
      userEmailInvalid,
      userEmailErrorMessage,
      setUserEmail,
      validateUserEmail,
      userPassword,
      userPasswordInvalid,
      userPasswordErrorMessage,
      setUserPassword,
      validateUserPassword,
      sendPasswordResetEmail,
      requestStatusMessage,
      loginRequestStatusType,
      loginModalOpen,
    } = loginStore;
    const { openRegisterModal } = registerStore;
    const isDesktop = uiStore?.isEqualOrGreatherThanBreakpoint("lg");

    let requestStatusMessageContainerClasses = [
      s.requestStatusMessageContainer,
    ];
    let requestStatusMessageClasses = [s.requestStatusMessage];
    if (requestStatusMessage !== "") {
      requestStatusMessageContainerClasses.push(s.visible);
      if (loginRequestStatusType === "error")
        requestStatusMessageClasses.push(s.error);
    }

    return (
      <Modal
        title={tx("authentication.login")}
        open={loginModalOpen}
        onClose={closeLoginModal}
      >
        <div className={s.titleWrapper}>
          <h3 className={s.title}>
            <span>
              {tx("authentication.signIn") +
                " " +
                tx("authentication.toYourAccount")}
            </span>
          </h3>
        </div>

        <div className={s.registerContainer}>
          <P medium className={s.registerText}>
            {tx("authentication.dontHaveAnAccount")}
          </P>

          <PseudoLink
            className={s.link}
            onClick={() => {
              closeLoginModal();
              openRegisterModal();
            }}
          >
            <P medium>{tx("authentication.registerNow")}</P>
          </PseudoLink>
        </div>
        <div className={s.contentContainer}>
          <div className={s.inputContainer}>
            <img
              src={Icons.email_small}
              alt="email-icon"
              className={s.inputIcon}
            />
            <Input
              type="email"
              label={`${tx("input.email")}:`}
              htmlFor="user-login-email"
              placeholder={tx("misc.startTyping")}
              value={userEmail}
              onChange={setUserEmail}
            />
          </div>
          <div className={s.inputContainer}>
            <img
              src={Icons.lock_small}
              alt="lock-icon"
              className={s.inputIcon}
            />
            <Input
              type="password"
              label={`${tx("input.password")}:`}
              htmlFor="user-login-password"
              placeholder={tx("misc.startTyping")}
              showIcon
              value={userPassword}
              onChange={setUserPassword}
              onEnter={login}
            />
          </div>
          <PseudoLink
            className={s.forgotPasswordLink}
            onClick={sendPasswordResetEmail}
          >
            <P small className={s.forgotPasswordText}>
              {tx("authentication.forgotPassword")}
            </P>
          </PseudoLink>
          <div className={requestStatusMessageContainerClasses.join(" ")}>
            <P small className={requestStatusMessageClasses.join(" ")}>
              {requestStatusMessage}
            </P>
          </div>
          <div className={s.buttonContainer}>
            <Button
              size={isDesktop ? "large" : "medium"}
              color="red"
              className={s.button}
              disabled={!userEmail?.length || !userPassword?.length}
              onClick={login}
            >
              {tx("authentication.signIn")}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
